import ProductModel from 'coreClasses/product/ProductModel';
import {ViewType} from 'brandConstants';
import {CustomerProductListItem} from 'coreStore/data/customerProductLists/types';

/**
 * Represents WishlistProductItemModel
 */
export default class WishlistProductItemModel {
	public variant_id: string;
	public quantity: number;
	public price: number;
	public master_id: string;
	public name: string;
	public brand: string;
	public size: string;
	public color: string;
	public url: string;
	public image: string;
	public category: string;

	/**
	 * @constructor
	 * @param {CustomerProductListItem} productItem - product item
	 * @param {ProductModel} product
	 */
	constructor(productItem: CustomerProductListItem, product: ProductModel) {
		this.variant_id = productItem.productId;
		this.quantity = productItem.quantity;
		this.price = product.getPriceModel().getMinPrice().value;

		this.master_id = productItem.c_variationGroupId;
		this.name = product.getName();
		this.brand = product.getBrand();
		this.size = product.getSize();
		this.color = product.getColorDescription();
		this.url = product.getProductUrl();
		this.image = product
			.getProductImage({
				viewType: ViewType.ZOOM,
				index: 0,
			})
			?.getUrl();
		this.category = product.getPrimaryCategoryId() || product.getCategoryId();
	}
}